var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFSideArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.03711 0.648438C6.13793 0.648438 6.21491 0.67885 6.29297 0.756836C6.37109 0.834961 6.40137 0.91179 6.40137 1.0127C6.40137 1.1136 6.37109 1.19043 6.29297 1.26855L1.58594 5.97559L1.93945 6.3291L6.29297 10.6816C6.37074 10.7594 6.3926 10.8265 6.38965 10.9072C6.38615 11.0012 6.35422 11.0822 6.26855 11.168C6.19048 11.246 6.1135 11.2773 6.0127 11.2773C5.91179 11.2773 5.83496 11.2461 5.75684 11.168L0.8125 6.22461C0.785341 6.19745 0.76548 6.17323 0.750977 6.15234L0.72168 6.09961C0.706868 6.06407 0.698289 6.02423 0.698242 5.97559C0.698242 5.95126 0.700106 5.92868 0.704102 5.9082L0.72168 5.85059C0.733395 5.82243 0.758335 5.77975 0.8125 5.72559L5.78223 0.756836C5.86015 0.679026 5.93652 0.648514 6.03711 0.648438Z",
    fill: "black",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFSideArrow);
export default __webpack_public_path__ + "static/media/f-side-arrow.177cd121c380c3f37e44818483d96c33.svg";
export { ForwardRef as ReactComponent };